import React, { createContext, useContext, useMemo } from 'react';
import { resourcesHr } from './resources.hr.js';

const LocalizationContext = createContext({
  locale: 'hr',
  resources: resourcesHr,
  t: (key) => key
});

function resolvePath(obj, key) {
  return String(key)
    .split('.')
    .reduce((current, segment) => (current && current[segment] !== undefined ? current[segment] : undefined), obj);
}

function formatTemplate(template, params = {}) {
  if (typeof template !== 'string') return template;
  return template.replace(/\{(\w+)\}/g, (_, paramName) => {
    const value = params[paramName];
    return value === undefined || value === null ? `{${paramName}}` : String(value);
  });
}

export function LocalizationProvider({ children, locale = 'hr', resources = resourcesHr }) {
  const value = useMemo(() => {
    const t = (key, params = {}, fallback = null) => {
      const localized = resolvePath(resources, key);
      const resolved = localized ?? fallback ?? key;
      return formatTemplate(resolved, params);
    };

    return {
      locale,
      resources,
      t
    };
  }, [locale, resources]);

  return <LocalizationContext.Provider value={value}>{children}</LocalizationContext.Provider>;
}

export function useLocalization() {
  return useContext(LocalizationContext);
}

export function useT() {
  const { t } = useLocalization();
  return t;
}
